// Core packages
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

// Third party packages
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";

// Custom packages
import { SuppliersService } from 'src/app/modules/suppliers/suppliers.service';
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";

@Component({
  selector: "supplier-security-video",
  templateUrl: "./supplierSecurityVideo.component.html",
  styleUrls: ["./supplierSecurityVideo.component.scss"],
})
export class SupplierSecurityVideoComponent implements OnInit, OnDestroy {
    private subscriptions: Subscription[] = [];
  lang = this.translateService.currentLang || this.translateService.defaultLang;

  showVideo = false;
  
  /**
   * Class constructor
   */
  constructor(
    public helperService: HelperService,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    public configService: ConfigService,
    private router: Router,
    private suppliersService: SuppliersService,
  ) {}

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    const url = this.activatedRoute.snapshot.url;

    if (url && Array.isArray(url) && url.length === 2) {
      const supplierId = url[1].path;
      this.subscriptions.push(
        this.suppliersService.setVideoSecurity(supplierId).subscribe(
          (res) => {
            if (res.status) {
              this.showVideo = true;
            } else {
              this.router.navigate([this.lang, "errors", "404"]);
            }
          },
          (err) => {
            // if we came here users with given userId do not exist
            this.router.navigate([this.lang, "errors", "404"]);
          }
        )
      );
    } else {
      this.router.navigate([this.lang, "errors", "404"]);
    }
  }
  
  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}